import type { IRawDimIssue } from '@skystone/shared';
import { rawDimIssueApi } from '@/services/raw-dim-issue-api';
import { useApi } from '@/hooks/useApi';
import { DataTable, ErrorBanner, PageHeader, PageLoading } from '@/components/ui';
import type { ColumnDef } from '@/components/ui';
import { buildRawColumns, buildStandardEmptyMessage, buildStandardTblSubtitle } from '@/lib/tbl-page-utils';
import { PageContainer } from '@/components/layout';

const issueColumns: ColumnDef<IRawDimIssue>[] = buildRawColumns<IRawDimIssue>([
  { key: 'id', header: 'ID' },
  { key: 'issueKey', header: 'Issue Key' },
  { key: 'issueName', header: 'Issue Name' },
  { key: 'issueType', header: 'Issue Type' },
  { key: 'teamId', header: 'Team ID' },
  { key: 'teamName', header: 'Team Name' },
  { key: 'assigneeName', header: 'Assignee Name' },
  { key: 'epicKey', header: 'Epic Key' },
  { key: 'epicName', header: 'Epic Name' },
  { key: 'labels', header: 'Labels' },
  { key: 'fabricSynced', header: 'Fabric Synced' },
  { key: 'fabricSyncedAt', header: 'Fabric Synced At' },
  { key: 'archived', header: 'Archived' },
  { key: 'archivedAt', header: 'Archived At' },
  { key: 'createdAt', header: 'Created At' },
  { key: 'updatedAt', header: 'Updated At' },
]);

export function TblDimIssuePage() {
  const { data: rows, loading, error } = useApi(() => rawDimIssueApi.getAll(), []);

  if (loading && !rows) {
    return <PageLoading />;
  }

  return (
    <PageContainer variant="wide" className="space-y-6">
      <PageHeader title="Tbl - dim_issue" subtitle={buildStandardTblSubtitle()} />
      <ErrorBanner message={error} />
      <DataTable
        data={rows ?? []}
        columns={issueColumns}
        keyExtractor={(row) => row.id}
        enablePagination
        enableFilters
        emptyMessage={buildStandardEmptyMessage('dim_issue')}
      />
    </PageContainer>
  );
}
